import { render, staticRenderFns } from "./ShortcutButton.vue?vue&type=template&id=69c8069e"
import script from "./ShortcutButton.vue?vue&type=script&lang=js"
export * from "./ShortcutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports